import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "main-content",
  class: "ml-64 p-8"
}
const _hoisted_2 = {
  id: "page-header",
  class: "mb-8"
}
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "space-y-2 mb-6" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = { class: "flex justify-end space-x-2 mt-5" }
const _hoisted_7 = { class: "space-y-2 mb-6" }
const _hoisted_8 = { class: "relative" }
const _hoisted_9 = { class: "flex justify-end space-x-2 mt-5" }
const _hoisted_10 = {
  id: "stats-section",
  class: "grid grid-cols-1 md:grid-cols-2 gap-6 mb-8"
}
const _hoisted_11 = { class: "bg-white p-6 rounded-lg shadow-sm border border-gray-200" }
const _hoisted_12 = { class: "flex items-center" }
const _hoisted_13 = { class: "ml-4" }
const _hoisted_14 = { class: "text-2xl font-semibold text-gray-900" }
const _hoisted_15 = { class: "bg-white p-6 rounded-lg shadow-sm border border-gray-200" }
const _hoisted_16 = { class: "flex items-center" }
const _hoisted_17 = { class: "ml-4" }
const _hoisted_18 = { class: "text-2xl font-semibold text-gray-900" }
const _hoisted_19 = {
  key: 0,
  id: "usage-guidelines",
  class: "mt-8 bg-green-50 border border-green-200 rounded-lg p-6 mb-4"
}
const _hoisted_20 = { class: "flex items-start" }
const _hoisted_21 = { class: "text-sm text-green-800 space-y-1" }
const _hoisted_22 = { class: "font-semibold" }
const _hoisted_23 = { class: "font-semibold" }
const _hoisted_24 = {
  id: "api-keys-table",
  class: "bg-white rounded-lg shadow-sm border border-gray-200"
}
const _hoisted_25 = {
  key: 0,
  class: "flex justify-center items-center h-32"
}
const _hoisted_26 = {
  key: 1,
  class: "overflow-x-auto"
}
const _hoisted_27 = { class: "w-full" }
const _hoisted_28 = { class: "bg-gray-50" }
const _hoisted_29 = {
  key: 0,
  class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
}
const _hoisted_30 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_31 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_32 = { class: "flex items-center" }
const _hoisted_33 = { class: "p-2 bg-indigo-100 rounded-lg mr-3" }
const _hoisted_34 = {
  key: 0,
  class: "fa-solid fa-globe text-indigo-600"
}
const _hoisted_35 = {
  key: 1,
  class: "fa-solid fa-flask text-yellow-600"
}
const _hoisted_36 = {
  key: 0,
  class: "text-sm font-medium text-gray-900"
}
const _hoisted_37 = {
  key: 1,
  class: "text-sm font-medium text-gray-900"
}
const _hoisted_38 = {
  key: 2,
  class: "text-sm text-gray-500"
}
const _hoisted_39 = {
  key: 3,
  class: "text-sm text-gray-500"
}
const _hoisted_40 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_41 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_42 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_43 = { class: "flex items-center" }
const _hoisted_44 = { class: "text-sm bg-gray-100 px-2 py-1 rounded" }
const _hoisted_45 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_46 = {
  key: 0,
  class: "inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800"
}
const _hoisted_47 = {
  key: 1,
  class: "inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-800"
}
const _hoisted_48 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_49 = { class: "px-6 py-4 whitespace-nowrap text-right text-sm font-medium" }
const _hoisted_50 = {
  key: 0,
  class: "flex space-x-2"
}
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { class: "px-6 py-4 border-t border-gray-200" }
const _hoisted_53 = { class: "flex items-center justify-between" }
const _hoisted_54 = { class: "text-sm text-gray-700" }
const _hoisted_55 = { class: "font-medium" }
const _hoisted_56 = { class: "font-medium" }
const _hoisted_57 = {
  key: 0,
  class: "flex items-center space-x-2"
}
const _hoisted_58 = { class: "px-3 py-1 bg-blue-600 text-white rounded text-sm" }
const _hoisted_59 = {
  key: 1,
  id: "usage-guidelines",
  class: "mt-8 bg-green-50 border border-green-200 rounded-lg p-6"
}

import { onMounted, ref, computed } from 'vue';
import { useAPIKeysStore } from '@/store/apikeys';
import { useNotificationStore } from '@/store/notifications';
import LottieAnimation from 'lottie-vuejs/src/LottieAnimation.vue';
import { useAuthStore } from '@/store/auth';
import Header from '../components/header.vue';
import SideBar from '../components/sidebar.vue';
import Modal from '../components/modal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'apikeys',
  setup(__props) {

const apiKeyStore = useAPIKeysStore();
const notificationStore = useNotificationStore();
const authStore = useAuthStore();

const showModal = ref(false);
const showUpdateModal = ref(false);
const selectedKey = ref<any>(null);
const selectedStatus = ref('');
const environment = ref('');
const loading = ref(false);
const apiKey = ref<string>('');
const apiSecret = ref<string>('');
const success = ref(false);


onMounted(() => {
  const purpose = localStorage.getItem('purpose');
  if (purpose === 'public') {
    apiKeyStore.getAPIKeys(1);
    apiKeyStore.getAPIKeyStats();
  } else if (purpose === 'local') {
    apiKeyStore.getAdminAPIKeys(1);
    apiKeyStore.getAdminAPIKeyStats();
  }
});

const isPublicPurpose = computed(() => {
  const purpose = localStorage.getItem('purpose');
  return purpose === 'public';
});

function formatDate(input: string) {
  const date = new Date(input);
  const formatted = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  }).format(date);
  return formatted;
}

function close() {
  showModal.value = false;
}

async function generateAPIKeys() {
  if (!environment.value) {
    notificationStore.showError('Validation Error', 'Please select an environment.');
    return;
  }

  loading.value = true;
  try {
    await apiKeyStore.generateAPIKeys(environment.value);

    if (apiKeyStore.error) {
      notificationStore.showError('API Key Generation Failed', apiKeyStore.error);
    } else {
      notificationStore.showSuccess('API Keys Generated', 'Your API keys have been generated successfully.');
      showModal.value = false;
      success.value = true;
      apiKey.value = apiKeyStore.apiKey || '';
      apiSecret.value = apiKeyStore.apiSecret || '';
      apiKeyStore.getAPIKeys(1);
    }
  } catch (err) {
    notificationStore.showError('API Key Error', 'An unexpected error occurred while generating API keys.');
  } finally {
    loading.value = false;
  }
}

async function copyToClipboard(text: string) {
  try {
    await navigator.clipboard.writeText(text);
    notificationStore.showSuccess('Copied to Clipboard', 'Text has been copied to your clipboard.');
    return true;
  } catch (err) {
    notificationStore.showError('Copy Failed', 'Failed to copy text to clipboard.');
    return false;
  }
}

function openUpdateModal(key: any) {
  selectedKey.value = key;
  selectedStatus.value = key.status;
  showUpdateModal.value = true;
}

async function updateApiKeyStatus() {
  if (!selectedStatus.value) {
    notificationStore.showError('Validation Error', 'Please select a status.');
    return;
  }

  loading.value = true;
  try {
    await apiKeyStore.updateAPIKeyStatus(selectedKey.value.id, selectedStatus.value);

    if (apiKeyStore.error) {
      notificationStore.showError('Update Failed', apiKeyStore.error);
    } else {
      notificationStore.showSuccess('Status Updated', 'API key status has been updated successfully.');
      showUpdateModal.value = false;
      await apiKeyStore.getAPIKeys(1);
    }
  } catch (err) {
    notificationStore.showError('Update Error', 'An unexpected error occurred while updating the API key.');
  } finally {
    loading.value = false;
  }
}

async function deleteApiKey(key: any) {
  if (!confirm('Are you sure you want to delete this API key?')) return;

  loading.value = true;
  try {
    await apiKeyStore.deleteAPIKey(key.id);

    if (apiKeyStore.error) {
      notificationStore.showError('Delete Failed', apiKeyStore.error);
    } else {
      notificationStore.showSuccess('API Key Deleted', 'The API key has been deleted successfully.');
      apiKeyStore.getAPIKeys(1);
    }
  } catch (err) {
    notificationStore.showError('Delete Error', 'An unexpected error occurred while deleting the API key.');
  } finally {
    loading.value = false;
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header),
    _createVNode(SideBar),
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[20] || (_cache[20] = _createElementVNode("div", null, [
            _createElementVNode("h2", { class: "text-2xl font-bold text-green-800" }, "API Keys"),
            _createElementVNode("p", { class: "mt-2 text-gray-600 text-sm" }, "Manage your API keys and access tokens")
          ], -1)),
          (_unref(authStore).hasPermissions('manage_api_keys', 'public'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                id: "create-key-btn",
                class: "bg-green-800 hover:bg-green-700 text-white px-6 py-3 rounded-md flex items-center space-x-2 font-medium text-white bg-gradient-to-r from-green-700 to-green-800 hover:from-green-700 hover:to-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg focus:ring-blue-500 transition-all duration-200 transform hover:scale-[1.02]",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = true))
              }, _cache[11] || (_cache[11] = [
                _createElementVNode("i", { class: "fa-solid fa-key mr-1" }, null, -1),
                _createElementVNode("span", null, "Generate APIKeys", -1)
              ])))
            : _createCommentVNode("", true),
          _createVNode(Modal, {
            show: showModal.value,
            title: "Generate APIKeys",
            size: "max-w-4xl",
            onClose: _cache[4] || (_cache[4] = ($event: any) => (showModal.value =
          false))
          }, {
            default: _withCtx(() => [
              _createElementVNode("form", {
                class: "space-y-6",
                onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (generateAPIKeys()), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-600" }, "Select Environment", -1)),
                  _createElementVNode("div", _hoisted_5, [
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center justify-center pointer-events-none" }, [
                      _createElementVNode("i", { class: "fa-solid fa-flask text-green-600 leading-none" })
                    ], -1)),
                    _withDirectives(_createElementVNode("select", {
                      id: "keyType",
                      class: "block w-full pl-10 pr-3 py-3 bg-white/10 border border-gray-500/20 rounded-sm border-gray-300 text-gray-600 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((environment).value = $event)),
                      required: ""
                    }, _cache[12] || (_cache[12] = [
                      _createElementVNode("option", { value: "" }, "Choose", -1),
                      _createElementVNode("option", { value: "Development" }, "Development", -1),
                      _createElementVNode("option", { value: "Production" }, "Production", -1)
                    ]), 512), [
                      [_vModelSelect, environment.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _renderSlot(_ctx.$slots, "footer", {}, () => [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (close())),
                      class: "px-4 py-1 bg-gray-300 rounded-sm hover:bg-gray-400"
                    }, " Close "),
                    _cache[15] || (_cache[15] = _createElementVNode("button", {
                      type: "submit",
                      class: "bg-green-800 hover:bg-green-700 text-white px-6 py-3 rounded-md flex items-center space-x-2 font-medium text-white bg-gradient-to-r from-green-700 to-green-800 hover:from-green-700 hover:to-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg focus:ring-blue-500 transition-all duration-200 transform hover:scale-[1.02]"
                    }, [
                      _createElementVNode("i", { class: "fa-solid fa-save mr-2" }),
                      _createTextVNode(" Generate ")
                    ], -1))
                  ])
                ])
              ], 32)
            ]),
            _: 3
          }, 8, ["show"]),
          _createVNode(Modal, {
            show: showUpdateModal.value,
            title: "Update API Key Status",
            size: "max-w-4xl",
            onClose: _cache[8] || (_cache[8] = ($event: any) => (showUpdateModal.value = false))
          }, {
            default: _withCtx(() => [
              _createElementVNode("form", {
                class: "space-y-6",
                onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (updateApiKeyStatus()), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[18] || (_cache[18] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-600" }, "Select Status", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center justify-center pointer-events-none" }, [
                      _createElementVNode("i", { class: "fa-solid fa-toggle-on text-green-600 leading-none" })
                    ], -1)),
                    _withDirectives(_createElementVNode("select", {
                      id: "status",
                      class: "block w-full pl-10 pr-3 py-3 bg-white/10 border border-gray-500/20 rounded-sm border-gray-300 text-gray-600 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedStatus).value = $event)),
                      required: ""
                    }, _cache[16] || (_cache[16] = [
                      _createElementVNode("option", { value: "" }, "Choose Status", -1),
                      _createElementVNode("option", { value: "ACTIVE" }, "Active", -1),
                      _createElementVNode("option", { value: "INACTIVE" }, "Inactive", -1),
                      _createElementVNode("option", { value: "REVOKED" }, "Revoked", -1)
                    ]), 512), [
                      [_vModelSelect, selectedStatus.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (showUpdateModal.value = false)),
                    class: "px-4 py-1 bg-gray-300 rounded-sm hover:bg-gray-400"
                  }, " Close "),
                  _cache[19] || (_cache[19] = _createElementVNode("button", {
                    type: "submit",
                    class: "bg-green-800 hover:bg-green-700 text-white px-6 py-3 rounded-md flex items-center space-x-2 font-medium text-white bg-gradient-to-r from-green-700 to-green-800 hover:from-green-700 hover:to-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg focus:ring-blue-500 transition-all duration-200 transform hover:scale-[1.02]"
                  }, [
                    _createElementVNode("i", { class: "fa-solid fa-save mr-2" }),
                    _createTextVNode(" Update ")
                  ], -1))
                ])
              ], 32)
            ]),
            _: 1
          }, 8, ["show"])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "p-3 bg-green-100 rounded-lg" }, [
              _createElementVNode("i", { class: "fa-solid fa-key text-green-600 text-xl" })
            ], -1)),
            _createElementVNode("div", _hoisted_13, [
              _cache[21] || (_cache[21] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Active Keys", -1)),
              _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(apiKeyStore).activekeysCount), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _cache[24] || (_cache[24] = _createElementVNode("div", { class: "p-3 bg-blue-100 rounded-lg" }, [
              _createElementVNode("i", { class: "fa-solid fa-chart-line text-blue-600 text-xl" })
            ], -1)),
            _createElementVNode("div", _hoisted_17, [
              _cache[23] || (_cache[23] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Monthly Requests", -1)),
              _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(apiKeyStore).monthlyUsageCount), 1)
            ])
          ])
        ])
      ]),
      (success.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _cache[29] || (_cache[29] = _createElementVNode("div", { class: "p-2 bg-green-100 rounded-lg mr-4" }, [
                _createElementVNode("i", { class: "fa-solid fa-check text-green-600" })
              ], -1)),
              _createElementVNode("div", null, [
                _cache[28] || (_cache[28] = _createElementVNode("h4", { class: "text-lg font-semibold text-green-900 mb-2" }, "API Keys generated successfully", -1)),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("p", _hoisted_22, [
                    _createTextVNode("Key: " + _toDisplayString(apiKey.value) + " ", 1),
                    _createElementVNode("button", {
                      class: "ml-2 text-green-400 hover:text-green-600",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (copyToClipboard(apiKey.value)))
                    }, _cache[25] || (_cache[25] = [
                      _createElementVNode("i", { class: "fa-solid fa-copy" }, null, -1)
                    ]))
                  ]),
                  _createElementVNode("p", _hoisted_23, [
                    _createTextVNode("Secret " + _toDisplayString(apiSecret.value), 1),
                    _createElementVNode("button", {
                      class: "ml-2 text-green-400 hover:text-green-600",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (copyToClipboard(apiSecret.value)))
                    }, _cache[26] || (_cache[26] = [
                      _createElementVNode("i", { class: "fa-solid fa-copy" }, null, -1)
                    ]))
                  ]),
                  _cache[27] || (_cache[27] = _createElementVNode("p", { class: "mt-8" }, "Please copy these keys and store them in a safe place. Please note that the secret key is visible only once", -1))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_24, [
        (_unref(apiKeyStore).loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createVNode(LottieAnimation, {
                path: "assets/images/loading.json",
                width: 150,
                height: 150
              })
            ]))
          : _createCommentVNode("", true),
        (!_unref(apiKeyStore).loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("table", _hoisted_27, [
                _createElementVNode("thead", _hoisted_28, [
                  _createElementVNode("tr", null, [
                    _cache[30] || (_cache[30] = _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Name", -1)),
                    _cache[31] || (_cache[31] = _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Organization", -1)),
                    _cache[32] || (_cache[32] = _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Key", -1)),
                    _cache[33] || (_cache[33] = _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Status", -1)),
                    _cache[34] || (_cache[34] = _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Created", -1)),
                    (_unref(authStore).hasPermissions('manage_api_keys', 'local'))
                      ? (_openBlock(), _createElementBlock("th", _hoisted_29, "Actions"))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("tbody", _hoisted_30, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(apiKeyStore).apiKeys, (keys) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      id: "api-key-1",
                      key: keys.id
                    }, [
                      _createElementVNode("td", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            (keys.credentialEnv.String ==
                      'Production')
                              ? (_openBlock(), _createElementBlock("i", _hoisted_34))
                              : _createCommentVNode("", true),
                            (keys.credentialEnv.String ==
                      'Development')
                              ? (_openBlock(), _createElementBlock("i", _hoisted_35))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", null, [
                            (keys.credentialEnv.String ==
                      'Production')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_36, "Production API"))
                              : _createCommentVNode("", true),
                            (keys.credentialEnv.String ==
                      'Development')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_37, "Development API"))
                              : _createCommentVNode("", true),
                            (keys.credentialEnv.String ==
                      'Production')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_38, "Main API production key"))
                              : _createCommentVNode("", true),
                            (keys.credentialEnv.String ==
                      'Development')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_39, "SandBox development key"))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, _toDisplayString(keys.organizationName), 1)
                      ]),
                      _createElementVNode("td", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("code", _hoisted_44, _toDisplayString(keys.apiKey) + "...", 1)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_45, [
                        (keys.status == 'ACTIVE')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_46, "ACTIVE"))
                          : _createCommentVNode("", true),
                        (keys.status != 'ACTIVE')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(keys.status.toUpperCase()), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_48, _toDisplayString(formatDate(keys.createdAt)), 1),
                      _createElementVNode("td", _hoisted_49, [
                        (_unref(authStore).hasPermissions('manage_api_keys', 'local'))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                              _createElementVNode("button", {
                                class: "text-indigo-600 hover:text-indigo-900",
                                onClick: ($event: any) => (openUpdateModal(keys))
                              }, _cache[35] || (_cache[35] = [
                                _createElementVNode("i", { class: "fa-solid fa-edit" }, null, -1)
                              ]), 8, _hoisted_51)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _cache[36] || (_cache[36] = _createTextVNode(" Showing ", -1)),
                    _createElementVNode("span", _hoisted_55, _toDisplayString(_unref(apiKeyStore).pagination.currentPage), 1),
                    _cache[37] || (_cache[37] = _createTextVNode(" of ", -1)),
                    _createElementVNode("span", _hoisted_56, _toDisplayString(_unref(apiKeyStore).pagination.totalPages), 1),
                    _cache[38] || (_cache[38] = _createTextVNode(" results ", -1))
                  ]),
                  (_unref(apiKeyStore).pagination.nextPage > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        _cache[39] || (_cache[39] = _createElementVNode("button", {
                          class: "px-3 py-1 border border-gray-300 rounded text-sm text-gray-500 hover:bg-gray-50",
                          disabled: ""
                        }, "Previous", -1)),
                        _createElementVNode("button", _hoisted_58, _toDisplayString(_unref(apiKeyStore).pagination.nextPage), 1),
                        _cache[40] || (_cache[40] = _createElementVNode("button", { class: "px-3 py-1 border border-gray-300 rounded text-sm text-gray-700 hover:bg-gray-50" }, "Next", -1))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (isPublicPurpose.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_59, _cache[41] || (_cache[41] = [
            _createStaticVNode("<div class=\"flex items-start\"><div class=\"p-2 bg-green-100 rounded-lg mr-4\"><i class=\"fa-solid fa-info-circle text-blue-600\"></i></div><div><h4 class=\"text-lg font-semibold text-green-900 mb-2\">API Key Security Guidelines</h4><ul class=\"text-sm text-green-800 space-y-1\"><li>• Keep your API keys secure and never share them publicly</li><li>• Use different keys for production and development environments</li><li>• Regularly rotate your API keys for enhanced security</li><li>• Monitor usage patterns to detect unauthorized access</li><li>• Set up proper rate limiting and access controls</li></ul></div></div>", 1)
          ])))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})